import { render } from "./swaps.vue?vue&type=template&id=63c00b52"
import script from "./swaps.vue?vue&type=script&lang=js"
export * from "./swaps.vue?vue&type=script&lang=js"

import "./swaps.vue?vue&type=style&index=0&id=63c00b52&lang=scss"

import exportComponent from "/Users/a/Documents/work/new/prnew/lk-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__